export default __webpack_public_path__ + "3a492c5f5d176db09b47ce9e651e79bd.svg";